import { PaymentMethod } from '../types';
import api from '../api';

export function add(customerId: string, paymentMethodId: string): Promise<PaymentMethod> {
  const url = `customers/${customerId}/payment-methods`;
  return api
    .post(url, { paymentMethodId })
    .then(response => response.data);
}

export function remove(id: string): Promise<void> {
  return api
    .delete(`payment-methods/${id}`)
    .then(response => response.data);
}

export function markAsPrimary(id: string): Promise<void> {
  return api
    .put(`payment-methods/${id}/primary`)
    .then(response => response.data);
}
